import React, { FC, memo } from 'react'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { authSelectors } from '@ucheba/store/auth'
import { useSelector } from 'react-redux'
import { ExamsList } from '../../../../../components/ExamsList/desktop'
import { useSpecialitiesPageEgeVariantsCore } from '../bll'

const SpecialitiesPageEgeVariants: FC = () => {
  const { getLinkProps, items, onClickGetMoreExam } = useSpecialitiesPageEgeVariantsCore()

  const isAuth = useSelector(authSelectors.isAuth)

  if (!items.length) return null

  return (
    <>
      <Spacing spacing='ularge' />

      <Heading h2='Специальности по набору ЕГЭ' spacing='large' />

      <LimitedList
        id='examList'
        items={items}
        limit={10}
        buttonText='Показать все наборы ЕГЭ'
        onShowAll={onClickGetMoreExam}
        isAuth={isAuth}
        // Андрей попросил пока захардкодить total
        total={100}
        showAllButtonLinkIsLink={false}
      >
        {({ limitedItems }) => (
          <ExamsList items={limitedItems} getLinkProps={getLinkProps} />
        )}
      </LimitedList>
    </>
  )
}

export default memo(SpecialitiesPageEgeVariants)
